import { MarkdownProps } from "components/common/ui/Markdown/Markdown";

import { StyledMarkdown } from "./SpMarkdown.Styled";

const SpMarkdown = ({ html, options, ...props }: MarkdownProps) => {
	return <StyledMarkdown html={html} options={options} {...props} />;
};

export default SpMarkdown;
